module.exports = __webpack_public_path__ + "static/img/gif1010.54bd4e0d.jpg";